import { HP, legSwing, pt } from '../enemy-parts';
/* ============================================================
   家族 WEDGE 楔 —— 低寬貼地＋正面斜面
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     KEIL    red 楔　突擊・衝刺
     PFLUG   amb 犁　推進・掃射
     AMBOSS  vio 砧　跳擊・震波
     KRIECHERred 匍匐　深層・貼地群衝
     LAICH   vio 卵塊　深層・叢生爆裂

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var WEDGE = [
  /* ─ 2 ─────────────────────────────────────────────────────────
     KEIL 楔 —— 低伏寬體，正面一整片斜甲。剪影＝壓在地上的三角形。
     AC6 的傾斜裝甲語彙在 20px 下唯一還讀得到的形式就是「整體是斜的」。 */
  {
    id:'keil', fam:'wedge', code:'KEIL', zh:'楔', role:'突擊・衝刺', tint:'red',
    sil:'低寬三角＋背鰭', h:0.92, w:1.36, wt:2.0,
    spd:2.2, turn:1.7, gait:2.2, rng:3.4, tTel:0.52, tAtk:0.34, tRec:0.70,
    q0:{lg:1, wg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'三連', q:{wg:0.82}, sp:1.32, sc:0.88},
          {n:'重楔', q:{wg:1.30}, sp:0.74, sc:1.18}],
    parts:[
      pt('bev','dark', [1.00,0.42,0.94],[0,0.42,0]),
      pt('box','armor',[1.20,0.70,0.26],[0,0.46,0.48],[-0.80,0,0], function(P,o){
          P.sx *= o.q.wg; P.rx -= o.tel*0.38; P.y += o.tel*0.10; }),
      pt('box','armor',[0.14,0.46,0.74],[0,0.76,-0.16],[0.18,0,0]),
      pt('box','glow', [0.96,0.07,0.07],[0,0.62,0.42], null, function(P,o){
          P.sy *= 1 + 2.2*o.tel; P.sz *= 1 + 2.2*o.tel; }),
      pt('bev','trim', [0.26,0.30,0.86],[ 0.50,0.17,-0.02],null, function(P,o){
          P.y += 0.02*Math.sin((o.ph)*Math.PI * 2*2)*o.mv; }),
      pt('bev','trim', [0.26,0.30,0.86],[-0.50,0.17,-0.02],null, function(P,o){
          P.y += 0.02*Math.sin((o.ph+0.5)*Math.PI * 2*2)*o.mv; })
    ],
    ex:[ pt('box','armorE',[0.30,0.44,0.90],[ 0.66,0.52,-0.06],[0,0,-0.30]),
         pt('box','armorE',[0.30,0.44,0.90],[-0.66,0.52,-0.06],[0,0, 0.30]),
         pt('cone','armorE',[0.20,0.50,0.20],[ 0.40,0.34,0.74],[1.34,0,0]),
         pt('cone','armorE',[0.20,0.50,0.20],[-0.40,0.34,0.74],[1.34,0,0]),
         pt('box','glowE',[0.10,0.10,0.60],[0,0.92,-0.18],[0.18,0,0]) ],
    pose:function(o){
      o.ry = 0.02*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = -o.tel*0.22 + o.atk*0.30;
      o.rr = 0;
      o.rz = -o.tel*0.40 + o.atk*2.30;
    }
  },
  /* ── 家族 WEDGE 楔 ── 低寬貼地、正面一整片斜面。red 是 KEIL。 */
  {
    id:'pflug', fam:'wedge', code:'PFLUG', zh:'犁', role:'推進・掃射', tint:'amb',
    sil:'低寬三角＋橫置雙管', h:0.88, w:1.44, wt:1.1,
    spd:1.8, turn:1.5, gait:2.0, rng:5.2, tTel:0.62, tAtk:0.40, tRec:0.80,
    q0:{lg:1, wg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'輕犁', q:{wg:0.84}, sp:1.34, sc:0.88},
          {n:'重犁', q:{wg:1.28}, sp:0.76, sc:1.16}],
    parts:[
      pt('bev','dark', [1.02,0.40,0.90],[0,0.40,0]),
      pt('box','armor',[1.16,0.62,0.24],[0,0.42,0.46],[-0.74,0,0], function(P,o){
          P.sx *= o.q.wg; P.rx -= o.tel*0.26; }),
      pt('cyl','armor',[0.17,0.86,0.17],[ 0.40,0.60,0.36],[HP,0,0], function(P,o){
          P.z -= o.atk*0.20; }),
      pt('cyl','armor',[0.17,0.86,0.17],[-0.40,0.60,0.36],[HP,0,0], function(P,o){
          P.z -= o.atk*0.20; }),
      pt('box','glow', [0.86,0.07,0.07],[0,0.72,0.10],null, function(P,o){
          P.sy *= 1 + 2.4*o.tel; P.sz *= 1 + 2.4*o.tel; }),
      pt('bev','trim', [0.26,0.28,0.80],[ 0.52,0.16,-0.04]),
      pt('bev','trim', [0.26,0.28,0.80],[-0.52,0.16,-0.04])
    ],
    ex:[ pt('box','armorE',[1.00,0.14,0.42],[0,0.66,-0.28],[0.22,0,0]),
         pt('cyl','glowE', [0.10,0.34,0.10],[0,0.62,0.62],[HP,0,0]) ],
    pose:function(o){
      o.ry = 0.026*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.06 + 0.05*o.mv - o.tel*0.12;
      o.rz = -o.atk*0.10;
    }
  },
  {
    id:'amboss', fam:'wedge', code:'AMBOSS', zh:'砧', role:'跳擊・震波', tint:'vio',
    sil:'低寬三角＋厚頂蓋', h:1.04, w:1.32, wt:1.0,
    spd:1.6, turn:1.4, gait:1.8, rng:2.8, tTel:0.90, tAtk:0.30, tRec:1.00,
    q0:{lg:1, bd:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'連跳', q:{bd:0.82}, sp:1.36, sc:0.88},
          {n:'重砧', q:{bd:1.26}, sp:0.72, sc:1.20}],
    parts:[
      pt('bev','dark', [0.98,0.52,0.86],[0,0.40,0], null, function(P,o){
          P.sx *= o.q.bd; P.sz *= o.q.bd; }),
      pt('box','armor',[1.14,0.34,0.72],[0,0.76,-0.02],[-0.16,0,0], function(P,o){
          P.sx *= o.q.bd; P.y += o.tel*0.16; }),
      pt('box','armor',[0.30,0.44,0.60],[0,0.88,-0.30],[0.24,0,0]),
      pt('tor','glow', [1.30,1.30,0.10],[0,0.08,0],[HP,0,0], function(P,o){
          var k = 1 + 0.9*o.tel + 3.2*o.atk; P.sx*=k; P.sy*=k;
          P.sz *= 1 + 4.0*o.atk*(1-o.atk); }),
      pt('cyl','trim', [0.26,0.44,0.26],[ 0.46,0.22,0.10], null, legSwing( 1,0.22,0.26)),
      pt('cyl','trim', [0.26,0.44,0.26],[-0.46,0.22,0.10], null, legSwing(-1,0.22,0.26))
    ],
    ex:[ pt('box','armorE',[0.34,0.26,0.34],[ 0.58,0.82,0.02],[0,0,-0.3]),
         pt('box','armorE',[0.34,0.26,0.34],[-0.58,0.82,0.02],[0,0, 0.3]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv - 0.16*o.tel + 1.05*Math.sin(o.atk*Math.PI);
      o.rp = 0.05 + 0.04*o.mv + 0.22*o.tel - 0.30*o.atk;
    }
  },
  {
    id:'kriecher', fam:'wedge', deep:1, code:'KRIECHER', zh:'匍匐', role:'深層・貼地群衝', tint:'red',
    sil:'低寬＋前緣一個洞', h:0.80, w:1.38, wt:2.4,
    spd:2.9, turn:2.0, gait:2.6, rng:1.7, tTel:0.30, tAtk:0.20, tRec:0.48,
    q0:{lg:1, wg:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'疾行', q:{lg:1.32}, sp:1.52, sc:0.86},
          {n:'厚甲', q:{wg:1.28}, sp:0.78, sc:1.18}],
    parts:[
      pt('bev','dark',[1.00,0.34,0.92],[0,0.32,0], null, function(P,o){ P.sx *= o.q.wg; }),
      pt('box','armor',[1.10,0.44,0.24],[0.08,0.34,0.44],[-0.72,0,0.10], function(P,o){
          P.sx *= o.q.wg; P.rx -= o.tel*0.30; }),
      pt('oct','void',[0.50,0.34,0.50],[-0.18,0.36,0.30]),
      pt('box','glow',[0.72,0.06,0.06],[0.16,0.46,0.34],[0,0,-0.16], function(P,o){
          P.sy *= 1 + 2.6*o.tel; P.sz *= 1 + 2.6*o.tel; }),
      pt('cone','trim',[0.12,0.48,0.12],[ 0.44,0.24,0.10],[Math.PI,0,0], legSwing( 1,0.24,0.46)),
      pt('cone','trim',[0.12,0.48,0.12],[-0.38,0.24,-0.06],[Math.PI,0,0], legSwing(-1,0.24,0.46)),
      pt('cone','trim',[0.10,0.40,0.10],[ 0.14,0.20,-0.30],[Math.PI,0,0], legSwing( 1,0.20,0.40))
    ],
    ex:[ pt('box','armorE',[0.86,0.12,0.34],[0,0.52,-0.22],[0.24,0,0.10]),
         pt('oct','glowE',[0.18,0.18,0.18],[-0.30,0.52,0.14]) ],
    pose:function(o){ o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.10 + 0.06*o.mv - o.tel*0.14; o.rr = 0.10*Math.sin(o.ph*Math.PI * 2)*o.mv + 0.05;
      o.rz = -o.tel*0.16 + o.atk*0.72; }
  },
  {
    id:'laich', fam:'wedge', deep:1, code:'LAICH', zh:'卵塊', role:'深層・叢生爆裂', tint:'vio',
    sil:'低寬＋三顆叢生球', h:0.98, w:1.26, wt:1.4,
    spd:1.5, turn:1.4, gait:1.7, rng:2.4, tTel:0.95, tAtk:0.24, tRec:0.60,
    q0:{bd:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'速孵', q:{bd:0.84}, sp:1.36, sc:0.86},
          {n:'母塊', q:{bd:1.28}, sp:0.72, sc:1.22}],
    parts:[
      pt('bev','dark',[0.94,0.32,0.86],[0,0.22,0]),
      pt('oct','armor',[0.72,0.72,0.72],[ 0.28,0.50, 0.10], null, function(P,o){
          var k = o.q.bd*(1 + 0.10*Math.sin(o.t*(3+16*o.tel))); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('oct','armor',[0.54,0.54,0.54],[-0.30,0.42,-0.14], null, function(P,o){
          var k = o.q.bd*(1 + 0.12*Math.sin(o.t*(3.6+16*o.tel)+1)); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('oct','void',[0.46,0.46,0.46],[-0.06,0.62, 0.26], null, function(P,o){
          var k = 1 + 0.8*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('tor','glow',[1.16,1.16,0.30],[0,0.14,0],[HP,0,0], function(P,o){
          var k = 1 + 0.7*o.tel + 3.0*o.atk; P.sx*=k; P.sy*=k; P.rz += o.t*(0.5+6*o.tel); }),
      pt('cone','trim',[0.14,0.42,0.14],[ 0.36,0.21,-0.20],[Math.PI,0,0], legSwing( 1,0.21,0.22)),
      pt('cone','trim',[0.14,0.42,0.14],[-0.40,0.21, 0.16],[Math.PI,0,0], legSwing(-1,0.21,0.22))
    ],
    ex:[ pt('oct','armorE',[0.40,0.40,0.40],[0.10,0.86,-0.10]),
         pt('tor','glowE',[0.66,0.66,0.30],[-0.06,0.62,0.26],[0.4,0.4,0]) ],
    pose:function(o){ o.ry = 0.05*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = 0.06 + 0.04*o.mv + o.tel*0.10; o.rr = 0.07; }
  }
];
